<template>
  <div class="actor_message">
    <div v-if="!isServerError">
      <section class="text_center" v-if="actor != null">
        <h2 class="header_underline">{{ title }}</h2>

        <div class="actor_message_input">
          <h3 v-if="!isComplete">{{ actorName }}</h3>
          <router-view v-bind:form.sync="form" v-bind:actor.sync="actor" @input="form = $event" />
        </div>
      </section>
    </div>
    <div v-else>
      <section class="not_found text_center">
        <div>
          <p>鑑定師が見つかりませんでした。</p>
          <p><router-link :to="{ name: 'Top' }" class="arrow link_main--text">トップページへ戻る</router-link></p>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { GET_ACTOR_BY_SETTING } from '@/store/actor/actions'

export default {
  name: 'ActorMessageBySetting',
  data () {
    return {
      id: this.$route.params.id,
      settingId: this.$route.params.settingId,
      actor: null,
      form: {
        errors: [],
        text: ''
      },
      isServerError: false
    }
  },
  computed: {
    title () {
      let titleStr = '鑑定依頼'
      if (this.isComplete) {
        titleStr = `${titleStr}完了`
      } else if (this.$route.meta.isConfirm) {
        titleStr = `${titleStr}内容確認`
      } else if (!this.$route.meta.isConfirm) {
        titleStr = `${titleStr}内容入力`
      }
      return titleStr
    },
    actorName () {
      return (this.actor == null) ? '' : `${this.actor.name}先生へ`
    },
    isComplete () {
      const meta = this.$route.meta || {}
      return 'isConfirm' in meta === false
    }
  },
  methods: {
    getActor () {
      this.actor = null

      this.$store.dispatch(GET_ACTOR_BY_SETTING, {
        id: this.id,
        settingId: this.settingId
      })
        .then((data) => {
          if (data.is_point_shortage) {
            this.$router.pushIsses({ name: 'UserPointShortage' })
          } else {
            this.actor = data
          }
        })
        .catch(() => {
          this.$router.go(-1)
        })
    }
  },
  created () {
    this.getActor()
  }
}
</script>
